import React from 'react';

function isPlainObject(v) {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

function renderValue(item) {
  const v = item.value;
  if (isPlainObject(v) || Array.isArray(v)) {
    return (
      <pre
        className="mt-1 w-full min-w-0 whitespace-pre-wrap rounded-md bg-black/35 px-2 py-1.5 text-left font-mono text-[10px] leading-relaxed text-amber-100/95 [overflow-wrap:anywhere] [tab-size:2]"
      >
        {JSON.stringify(v, null, 2)}
      </pre>
    );
  }
  return (
    <span className="min-w-0 break-words text-right font-mono text-[11px] text-amber-100/95">
      {String(v)}
    </span>
  );
}

export function DebugPanel({ title = 'Debug', items = [], className = '' }) {
  if (!items.length) return null;

  return (
    <section
      className={`rounded-xl border border-amber-400/25 bg-amber-400/5 px-3 py-2 ${className}`}
      aria-label="Admin debug details"
    >
      <p className="text-[10px] font-display font-black uppercase tracking-[0.16em] text-amber-300">
        {title}
      </p>
      <dl className="mt-2 grid grid-cols-1 gap-2">
        {items.map((item) => {
          const v = item.value;
          const block = isPlainObject(v) || Array.isArray(v);
          return (
            <div
              key={item.label}
              className={
                block
                  ? 'flex min-w-0 flex-col gap-0.5 text-left'
                  : 'flex min-w-0 items-start justify-between gap-3'
              }
            >
              <dt className="shrink-0 text-[11px] text-beachvision-muted">{item.label}</dt>
              <dd
                className={
                  block
                    ? 'm-0 min-w-0'
                    : 'm-0 flex min-w-0 flex-1 justify-end text-[11px] font-medium'
                }
              >
                {renderValue(item)}
              </dd>
            </div>
          );
        })}
      </dl>
    </section>
  );
}
